import React from 'react';
import Header from './Header';
import Content from './Content';
import Footer from '../../components/Footer';
import { useTitle } from '../../hooks/useTitle';

const RegisterTempIndex = () => {
  useTitle('Ton Bébé | 仮登録完了');

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="register_temp">
          <h1 className="sec_title">仮登録完了</h1>
          <Content />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default RegisterTempIndex;
